<div class="timeline-circle"></div>

<p class="g4">
  KOD: <strong class="g3">{{ dashboardDeposit.getCode() || '-' }}</strong>
</p>
<p class="g4 mt8">STATUS DEPOZYTU</p>
<p class="signal-success-green">{{ dashboardDeposit.getStatus() || '-' }}</p>
<p class="mt8">{{ dashboardDeposit.getNameFormatted() || '-' }}</p>
<app-tyre-info [dashboardDeposit]="dashboardDeposit.getResource()"></app-tyre-info>
